export const createArrUtils = (numberOfElements: number): number[] => {
    const arr = Array.from(Array(numberOfElements + 1).keys())
    arr.shift()
    return arr
}
